<!-- Dialog Header -->
<div class="flex flex-col p-4" >
  <div class="flex justify-between items-center">
    <div class="flex items-center gap-3">
      <mat-icon class="text-blue-600 w-6 h-6">upload</mat-icon>
      <h2 class="text-lg font-medium">Asistente de importación <span *ngIf="config?.title">{{ config?.title }}</span></h2>
    </div>
    <div *ngIf="errorCollection.getTotalErrors() > 0" class="flex items-center gap-2 text-red-600">
      <mat-icon class="w-4 h-4">close</mat-icon>
      <span class="font-medium">{{ errorCollection.getTotalErrors() }} errores</span>
    </div>
  </div>

  <!-- Import Progress Bar -->
  <mat-progress-bar
    *ngIf="progress && isImporting"
    mode="determinate"
    [value]="progress.percentage"
    class="mt-2"
  ></mat-progress-bar>

  <!-- Pre-Validation Progress Bar -->
  <mat-progress-bar
    *ngIf="config.preValidation?.enabled && isPreValidating"
    mode="indeterminate"
    color="accent"
    class="mt-2"
  ></mat-progress-bar>
  <div *ngIf="config.preValidation?.enabled && isPreValidating" class="text-sm text-gray-600 mt-1">
    Pre-validando datos...
  </div>
</div>

<!-- Dialog Content -->
<mat-dialog-content class="flex flex-col flex-1 px-4 pt-0 pb-2 overflow-hidden">
  <!-- File Upload Section -->
  <div
    *ngIf="!isFileSelected || dataSource?.length === 0"
    class="flex flex-col items-center justify-center h-full min-h-[300px]"
  >
    <div
      class="border-2 border-dashed border-gray-300 rounded-lg p-12 text-center cursor-pointer transition-all duration-300 bg-gray-50 max-w-md w-full hover:border-blue-600 hover:bg-blue-50"
      [class.drag-over]="dragOver"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()"
      (drop)="onFileDrop($event)"
      (click)="fileInput.click()"
    >
      <div>
        <mat-icon class="text-blue-600 text-5xl mb-4">cloud_upload</mat-icon>
        <h3 class="font-medium mb-2">Selecciona o arrastra tu archivo Excel</h3>
        <p class="text-sm text-gray-600">
          Formatos aceptados: .xlsx, .xls
          <span *ngIf="config.maxFileSize">
            | Tamaño máximo: {{ config.maxFileSize / 1024 / 1024 | number: '1.0-0' }}MB
          </span>
        </p>
      </div>
      <input
        #fileInput
        type="file"
        accept=".xlsx,.xls"
        class="hidden"
        (change)="onFileSelected($event)"
      />
    </div>

    <!-- Processing indicator -->
    <div *ngIf="isProcessing" class="mt-6 max-w-md w-full text-center">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p class="mt-4 text-gray-600">Procesando archivo...</p>
    </div>
  </div>

  <!-- Data Preview Section -->
  <div *ngIf="isFileSelected && processedFile" class="flex flex-col flex-1 overflow-hidden">
    <!-- Sheet Tabs -->

    <!-- <mat-tab-group
      *ngIf="processedFile.sheets.length > 1"
      [(selectedIndex)]="selectedSheetIndex"
      (selectedIndexChange)="selectSheet($event)"
      class="flex flex-col flex-1"
    >
      <mat-tab *ngFor="let sheet of processedFile.sheets; let i = index" [label]="sheet.name">
        <ng-container *ngTemplateOutlet="dataTableTemplate"></ng-container>
      </mat-tab>
    </mat-tab-group> -->

    <!-- Single Sheet Display -->
    <div *ngIf="processedFile" class="flex flex-col flex-1 overflow-hidden">
      <ng-container *ngTemplateOutlet="dataTableTemplate"></ng-container>
    </div>
  </div>
</mat-dialog-content>

<!-- Dialog Actions -->
<mat-dialog-actions
  class="flex justify-between items-center p-4 border-t border-gray-300 bg-gray-50"
>
  <div class="flex items-center gap-3">
    <button
      *ngIf="isFileSelected"
      mat-button
      color="accent"
      (click)="reUploadFile()"
      [disabled]="isImporting"
    >
      <mat-icon>refresh</mat-icon>
      Reemplazar excel
    </button>
    <button
      *ngIf="isFileSelected && (hasInvalidRecords() || hasProcessedRecords())"
      mat-button
      color="warn"
      [matMenuTriggerFor]="recordManagementMenu"
      [disabled]="isImporting"
    >
      <mat-icon>manage_accounts</mat-icon>
      Gestionar Registros
    </button>
  </div>
  <div class="flex items-center gap-3">
    <!-- Pre-Validation Manual Button -->
    <button
      *ngIf="config.preValidation?.enabled && config.preValidation.mode === 'manual' && isFileSelected"
      mat-stroked-button
      color="accent"
      [disabled]="isPreValidating || isImporting || !dataSource || dataSource.length === 0"
      (click)="executePreValidation()"
      matTooltip="Pre-validar datos con el servidor"
    >
      <mat-icon>fact_check</mat-icon>
      Pre-validar
    </button>

    <!-- Skip Pre-Validation Checkbox (optional mode only) -->
    <mat-checkbox
      *ngIf="config.preValidation?.enabled && !config.preValidation.required && isFileSelected"
      [(ngModel)]="skipPreValidation"
      [disabled]="isImporting || isPreValidating"
      matTooltip="Omitir la pre-validación opcional"
      class="text-sm"
    >
      Omitir pre-validación
    </mat-checkbox>

    <!-- Retry Pre-Validation Button (error state) -->
    <button
      *ngIf="config.preValidation?.enabled && preValidationFailed"
      mat-stroked-button
      color="warn"
      [disabled]="isPreValidating || isImporting"
      (click)="retryPreValidation()"
      matTooltip="{{ preValidationErrorMessage }}"
    >
      <mat-icon>refresh</mat-icon>
      Reintentar pre-validación
    </button>

    <span *ngIf="progress" class="text-sm italic text-gray-600">{{ progress.message }}</span>
    <button mat-button (click)="cancel()" [disabled]="isImporting">Cancelar</button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="!canImport()"
      (click)="checkForProcessedRecordsAndImport()"
    >
      <mat-icon>save</mat-icon>
      <span *ngIf="!isImporting && !hasProcessedRecords()">Importar</span>
      <span *ngIf="!isImporting && hasProcessedRecords()"
        >Importar pendientes ({{ getUnprocessedValidRecords().length }})</span
      >
      <span *ngIf="isImporting">Importando...</span>
    </button>
  </div>
</mat-dialog-actions>

<!-- Data Table Template -->
<ng-template #dataTableTemplate>
  <div *ngIf="currentSheet && dataSource.length > 0" class="flex flex-col flex-1 overflow-hidden">
    <!-- Filter Toolbar -->
    <div class="border border-gray-300 rounded-t p-3">
      <!-- First Row: Search and Error/Valid Filter -->
      <div class="flex items-center gap-x-4">
        <!-- Global Search -->
        <mat-form-field  class="flex-1 max-w-md">
          <mat-label>Buscar en todas las columnas</mat-label>
          <input
            matInput
            [value]="filters.globalSearch"
            (input)="onGlobalSearchChange($any($event.target).value)"
            placeholder="Escribir para buscar..."
          />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <!-- Record State Filter -->
        <mat-form-field  class="min-w-52">
          <mat-label>Filtrar por estado</mat-label>
          <mat-select
            [value]="getCurrentFilterValue()"
            (selectionChange)="onErrorFilterChange($event.value)"
          >
            <mat-option value="all">Todos los registros</mat-option>
            <mat-option value="errors">Solo registros con errores</mat-option>
            <mat-option value="valid">Solo registros válidos</mat-option>
            <mat-option value="processed" *ngIf="hasProcessedRecords()"
              >Solo registros procesados</mat-option
            >
            <mat-option value="pending">Solo registros pendientes</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Column Visibility Toggle -->
        <button
          mat-icon-button
          (click)="showColumnPanel = !showColumnPanel"
          [matTooltip]="getHiddenColumnsCount() > 0
            ? getHiddenColumnsCount() + ' columna(s) oculta(s)'
            : 'Gestionar columnas visibles'"
          class="column-toggle-btn">
          <mat-icon>view_column</mat-icon>
          <span
            *ngIf="getHiddenColumnsCount() > 0"
            class="hidden-badge">
            {{ getHiddenColumnsCount() }}
          </span>
        </button>

        <!-- Reset Filters -->
        <button
          mat-stroked-button
          color="accent"
          [disabled]="getActiveFiltersCount() === 0"
          (click)="resetAllFilters()"
          matTooltip="Limpiar todos los filtros"
        >
          <mat-icon>clear</mat-icon>
          Limpiar Filtros
        </button>
      </div>

      <!-- Filter Summary -->
      <div class="flex items-center justify-between text-sm text-gray-600">
        <span>
          Mostrando {{ filteredRecordsCount }} de {{ totalRecords }} registros
          <span *ngIf="activeFiltersCount > 0" class="font-medium">
            ({{ activeFiltersCount }} filtros activos)
          </span>
        </span>
        <div class="flex items-center gap-4">
          <span class="flex items-center gap-1 text-green-600" *ngIf="processedRecordsCount > 0">
            <mat-icon class="w-4 h-4">check_circle</mat-icon>
            {{ processedRecordsCount }} procesados
          </span>
          <span class="flex items-center gap-1 text-purple-600" *ngIf="config.preValidation?.enabled && preValidatedCount > 0">
            <mat-icon class="w-4 h-4">verified</mat-icon>
            {{ preValidatedCount }} pre-validadas
          </span>
          <span class="flex items-center gap-1 text-red-600" *ngIf="invalidRecordsCount > 0">
            <mat-icon class="w-4 h-4">close</mat-icon>
            {{ invalidRecordsCount }} con errores
          </span>
          <span
            class="flex items-center gap-1 text-blue-600"
            *ngIf="unprocessedValidRecordsCount > 0"
          >
            <mat-icon class="w-4 h-4">pending</mat-icon>
            {{ unprocessedValidRecordsCount }} pendientes
          </span>
        </div>
      </div>
    </div>

    <!-- Virtual Scrolling Mat-Table -->
    <div class="flex-1 border border-gray-300 rounded-b overflow-hidden">
      <cdk-virtual-scroll-viewport
        tvsItemSize="50"
        [headerHeight]="headerHeight"
        class="virtual-table-wrapper">

        <table class="import-dialog-container-table" mat-table [dataSource]="virtualTableDataSource">

          <!-- Table Header and Rows with Sticky -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns; trackBy: trackByRowIndex"
              [class.error-row]="getRowErrorCountOptimized(row) > 0 || isRecordError(row.rowIndex)"
              [class.success-row]="isRecordProcessed(row.rowIndex) && getRowErrorCountOptimized(row) === 0">
          </tr>

          <!-- Row Number Column (Sticky) -->
          <ng-container matColumnDef="rowNumber" sticky>
            <th mat-header-cell *matHeaderCellDef class="row-number-header !px-5">
              <span class="font-semibold">#</span>
            </th>
            <td mat-cell *matCellDef="let element; let i = index"
                class="row-number-cell text-center !px-5"
                [class.bg-red-100]="getRowErrorCountOptimized(element) > 0 || isRecordError(element.rowIndex)"
                [class.bg-green-100]="isRecordProcessed(element.rowIndex)">
              <div class="flex items-center justify-center gap-1 h-full">
                <span class="font-medium">{{ element.rowIndex + 1 }}</span>

                <!-- Pre-validation success icon -->
                <mat-icon *ngIf="config.preValidation?.enabled && element.formGroup.get('_preValidationResult')?.value === 'success'"
                          class="text-purple-600 w-4 h-4 flex-shrink-0"
                          matTooltip="Pre-validación exitosa">
                  verified
                </mat-icon>


                <!-- Frontend/API errors icon -->
                <button mat-icon-button (click)="showRowErrors(element)" *ngIf="getRowErrorCountOptimized(element) > 0 || isRecordError(element.rowIndex)"   [matTooltip]="getRowErrorCountOptimized(element) > 0
                  ? getRowErrorCountOptimized(element) + ' errores en esta fila'
                  : 'Error de procesamiento de API'">
                  <mat-icon class="text-red-600 w-4 h-4">close</mat-icon>
                </button>

                <!-- Processed successfully icon -->
                <mat-icon *ngIf="isRecordProcessed(element.rowIndex)"
                          class="text-green-600 w-4 h-4 flex-shrink-0"
                          matTooltip="Registro procesado exitosamente">
                  check_circle
                </mat-icon>
              </div>
            </td>
          </ng-container>

          <!-- Dynamic Data Columns -->
          <ng-container *ngFor="let column of config.columns" [matColumnDef]="column.key">
            <th mat-header-cell *matHeaderCellDef
                class="data-column-header sortable-header !px-5"
                [class.sorted]="isSortedBy(column.key)"
                (click)="onColumnSort(column.key)">
              <div class="flex items-center justify-between w-full h-full cursor-pointer">
                <div class="flex items-center gap-1 min-w-0 flex-1">
                  <span class="font-semibold truncate">{{ column.displayName }}</span>
                  <span *ngIf="column.required"
                        class="text-red-500 text-md font-semibold flex-shrink-0 ml-0.5">(*)</span>
                  <!-- Sort Indicator -->
                  <mat-icon *ngIf="isSortedBy(column.key)"
                            class="text-blue-600 w-4 h-4 flex-shrink-0 sort-icon"
                            [matTooltip]="'Ordenado ' + (getSortDirection(column.key) === 'asc' ? 'ascendente' : 'descendente')">
                    {{ getSortIcon(column.key) }}
                  </mat-icon>
                </div>
                <!-- Column Filter Button -->
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="columnFilterMenu"
                  [matMenuTriggerData]="{ columnKey: column.key }"
                  [class.text-blue-600]="isColumnFilteredOptimized(column.key)"
                  [matTooltip]="'Filtrar columna ' + getColumnDisplayName(column.key)"
                  class="w-6 h-6 flex-shrink-0"
                  (click)="$event.stopPropagation()">
                  <mat-icon class="text-sm">
                    {{ isColumnFilteredOptimized(column.key) ? 'filter_alt' : 'filter_list' }}
                  </mat-icon>
                </button>
              </div>
            </th>
            <td mat-cell *matCellDef="let element"
                class="data-column-cell !px-5"
                [class.bg-red-100]="hasCellErrorOptimized(element, column.key) || isRecordError(element.rowIndex)"
                [class.bg-green-100]="isRecordProcessed(element.rowIndex) && !hasCellErrorOptimized(element, column.key)"
                [class.bg-blue-50]="config.preValidation?.enabled && isRelatedColumn(column)"
                [class.related-column]="config.preValidation?.enabled && isRelatedColumn(column)">
              <div class="flex items-center gap-2 w-full h-full min-w-0">
                <span class="flex-1"
                      [matTooltip]="hasCellErrorOptimized(element, column.key)
                        ? getCellErrorsTooltipOptimized(element, column.key)
                        : (getCellValue(element, column.key) || '')"
                      matTooltipPosition="above">
                  {{ getCellValue(element, column.key) || '-' }}
                </span>
                <mat-icon *ngIf="hasCellErrorOptimized(element, column.key)"
                          class="text-red-600 w-4 h-4 flex-shrink-0">
                  close
                </mat-icon>
                <!-- Related column indicator -->
                <mat-icon *ngIf="config.preValidation?.enabled && isRelatedColumn(column)"
                          class="text-blue-600 w-4 h-4 flex-shrink-0"
                          matTooltip="Columna relacionada (auto-completada)">
                  link
                </mat-icon>
              </div>
            </td>
          </ng-container>

          <!-- Dynamic Related Columns (not in config.columns) -->
          <ng-container *ngFor="let entry of relatedColumnsMetadata | keyvalue" [matColumnDef]="entry.key">
            <th mat-header-cell *matHeaderCellDef class="data-column-header !px-5">
              <div class="flex items-center gap-1 min-w-0">
                <span class="font-semibold truncate">{{ entry.value.displayName }}</span>
                <mat-icon class="text-blue-600 w-4 h-4 flex-shrink-0"
                          matTooltip="Columna auto-completada por pre-validación">
                  auto_awesome
                </mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let element"
                class="data-column-cell !px-5 bg-blue-50 related-column">
              <div class="flex items-center gap-2 w-full h-full min-w-0">
                <span class="flex-1"
                      [matTooltip]="getCellValue(element, entry.key) || ''"
                      matTooltipPosition="above">
                  {{ getCellValue(element, entry.key) || '-' }}
                </span>
                <mat-icon class="text-blue-600 w-4 h-4 flex-shrink-0"
                          matTooltip="Auto-completado">
                  link
                </mat-icon>
              </div>
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions-header !px-5">
              <span class="font-semibold">Acciones</span>
            </th>
            <td mat-cell *matCellDef="let element" class="actions-cell text-center !px-5">
              <div class="flex items-center justify-center h-full">
                <button (click)="showRowErrors(element)"
                        mat-icon-button
                        *ngIf="getRowErrorCountOptimized(element) > 0 || isRecordError(element.rowIndex)"
                        matTooltip="Ver errores de la fila"
                        color="warn">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

        </table>
      </cdk-virtual-scroll-viewport>
    </div>

    <!-- No Data Message -->
    <div
      *ngIf="dataSource.length === 0"
      class="flex flex-col items-center justify-center p-12 text-gray-600"
    >
      <mat-icon class="text-5xl mb-4">info</mat-icon>
      <p class="text-lg">No se encontraron datos válidos en la hoja seleccionada</p>
    </div>
  </div>
</ng-template>

<!-- Column Visibility Panel -->
<div
  class="column-visibility-panel"
  [class.open]="showColumnPanel"
  *ngIf="config?.columns?.length > 0 && isFileSelected">

  <!-- Header del panel -->
  <div class="panel-header">
    <div class="flex items-center gap-2">
      <mat-icon class="text-blue-600">view_column</mat-icon>
      <h3 class="text-base font-semibold">Gestión de Columnas</h3>
    </div>
    <button
      mat-icon-button
      (click)="showColumnPanel = false"
      matTooltip="Cerrar panel">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Estadísticas -->
  <div class="panel-stats">
    <div class="stat-item">
      <mat-icon class="stat-icon text-green-600">visibility</mat-icon>
      <span class="stat-text">
        <strong>{{ getVisibleColumnsCount() }}</strong> visibles
      </span>
    </div>
    <div class="stat-divider"></div>
    <div class="stat-item">
      <mat-icon class="stat-icon text-gray-500">visibility_off</mat-icon>
      <span class="stat-text">
        <strong>{{ getHiddenColumnsCount() }}</strong> ocultas
      </span>
    </div>
  </div>

  <!-- Acciones rápidas -->
  <div class="panel-actions">
    <button
      mat-stroked-button
      (click)="showAllColumns()"
      class="action-btn">
      <mat-icon>visibility</mat-icon>
      Mostrar todas
    </button>
    <button
      mat-stroked-button
      (click)="resetColumnVisibility()"
      class="action-btn">
      <mat-icon>refresh</mat-icon>
      Restablecer
    </button>
  </div>

  <!-- Lista de columnas con checkboxes -->
  <div class="panel-content">
    <div class="section-header">
      <span class="text-xs font-semibold text-gray-500 uppercase">Columnas disponibles</span>
    </div>

    <div class="columns-list">
      <!-- Config Columns -->
      <div
        *ngFor="let column of config.columns; trackBy: trackByColumnKey"
        class="column-list-item"
        [class.is-visible]="isColumnVisible(column.key)"
        [class.is-hidden]="!isColumnVisible(column.key)">

        <mat-checkbox
          [checked]="isColumnVisible(column.key)"
          [disabled]="column.required && !isColumnEmpty(column.key)"
          (change)="toggleColumnVisibility(column.key)"
          class="column-checkbox">

          <div class="column-info">
            <span class="column-name">{{ column.displayName }}</span>

            <!-- Badges -->
            <div class="column-badges">
              <span
                *ngIf="column.required"
                class="badge badge-required"
                matTooltip="Esta columna es requerida y siempre debe ser visible">
                Requerida
              </span>
              <span
                *ngIf="isColumnEmpty(column.key)"
                class="badge badge-empty"
                matTooltip="Esta columna está vacía en todos los registros">
                Vacía
              </span>
            </div>
          </div>
        </mat-checkbox>
      </div>

      <!-- Related Columns (Auto-populated from Pre-validation) -->
      <div *ngIf="relatedColumnsMetadata.size > 0" class="section-divider">
        <span class="text-xs font-semibold text-blue-600 uppercase">Columnas Auto-completadas</span>
      </div>

      <div
        *ngFor="let entry of relatedColumnsMetadata | keyvalue"
        class="column-list-item"
        [class.is-visible]="isColumnVisible(entry.key)"
        [class.is-hidden]="!isColumnVisible(entry.key)">

        <mat-checkbox
          [checked]="isColumnVisible(entry.key)"
          (change)="toggleColumnVisibility(entry.key)"
          class="column-checkbox">

          <div class="column-info">
            <span class="column-name">{{ entry.value.displayName }}</span>

            <!-- Badge for auto-completed columns -->
            <div class="column-badges">
              <span
                class="badge badge-autocomplete"
                matTooltip="Esta columna fue auto-completada por pre-validación">
                Auto-completada
              </span>
            </div>
          </div>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <!-- Info footer -->
  <div class="panel-footer">
    <div class="info-box">
      <mat-icon class="info-icon">info</mat-icon>
      <p class="info-text">
        Las columnas <strong>requeridas</strong> siempre son visibles.
        Las columnas <strong>opcionales vacías</strong> se ocultan automáticamente.
      </p>
    </div>
  </div>
</div>

<!-- Overlay para cerrar panel al hacer click fuera -->
<div
  class="panel-overlay"
  *ngIf="showColumnPanel"
  (click)="showColumnPanel = false">
</div>

<!-- Record Management Menu -->
<mat-menu #recordManagementMenu="matMenu">
  <!-- Invalid Records Section -->
  <div *ngIf="hasInvalidRecords()" class="px-3 py-2 text-sm font-medium text-gray-700 border-b">
    Registros con Errores ({{ getInvalidRecords().length }})
  </div>
  <button *ngIf="hasInvalidRecords()" mat-menu-item (click)="removeInvalidRecords()">
    <mat-icon>delete</mat-icon>
    <span>Eliminar Registros con Errores</span>
  </button>
  <button *ngIf="hasInvalidRecords()" mat-menu-item [matMenuTriggerFor]="invalidExportOptionsMenu">
    <mat-icon>save_alt</mat-icon>
    <span>Exportar/Copiar Registros con Errores</span>
  </button>

  <!-- Processed Records Section -->
  <div
    *ngIf="hasProcessedRecords()"
    class="px-3 py-2 text-sm font-medium text-gray-700 border-b border-t"
  >
    Registros Procesados ({{ getProcessedRecords().length }})
  </div>
  <button *ngIf="hasProcessedRecords()" mat-menu-item (click)="removeProcessedRecords()">
    <mat-icon>delete</mat-icon>
    <span>Eliminar Registros Procesados</span>
  </button>
  <button
    *ngIf="hasProcessedRecords()"
    mat-menu-item
    [matMenuTriggerFor]="processedExportOptionsMenu"
  >
    <mat-icon>save_alt</mat-icon>
    <span>Exportar Registros Procesados</span>
  </button>

  <mat-divider></mat-divider>
</mat-menu>

<!-- Invalid Records Export Options -->
<mat-menu #invalidExportOptionsMenu="matMenu">
  <button mat-menu-item (click)="exportInvalidRecordsToExcel()">
    <mat-icon>file_download</mat-icon>
    <span>Exportar a Excel</span>
  </button>
  <button mat-menu-item (click)="copyInvalidRecordsToClipboard()">
    <mat-icon>content_copy</mat-icon>
    <span>Copiar Lista al Portapapeles</span>
  </button>
  <button mat-menu-item (click)="exportInvalidRecordsToExcel(); copyInvalidRecordsToClipboard()">
    <mat-icon>file_copy</mat-icon>
    <span>Ambas Opciones</span>
  </button>
</mat-menu>

<!-- Processed Records Export Options -->
<mat-menu #processedExportOptionsMenu="matMenu">
  <button mat-menu-item (click)="exportProcessedRecordsToExcel()">
    <mat-icon>file_download</mat-icon>
    <span>Exportar a Excel</span>
  </button>
</mat-menu>

<!-- Column Filter Menu -->
<mat-menu #columnFilterMenu="matMenu" class="column-filter-menu">
  <ng-template matMenuContent let-columnKey="columnKey">
    <div class="p-4 min-w-64 max-w-80" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between mb-3">
        <h4 class="font-medium text-gray-800">Filtrar: {{ getColumnDisplayName(columnKey) }}</h4>
        <button
          mat-icon-button
          (click)="onColumnFilterChange(columnKey, getColumnFilterValues(columnKey))"
          matTooltip="Limpiar filtro de columna"
        >
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <!-- Search input for large filter lists -->
      <div *ngIf="getColumnFilterValues(columnKey).length > 5" class="mb-3">
        <mat-form-field  class="w-full">
          <mat-label>Buscar valores ({{ getFilteredColumnValues(columnKey).length }}/{{ getColumnFilterValues(columnKey).length }})</mat-label>
          <input
            matInput
            [value]="getColumnFilterSearch(columnKey)"
            (input)="onColumnFilterSearchChange(columnKey, $any($event.target).value)"
            placeholder="Escribir para filtrar..."
            autocomplete="off"
          />
          <mat-icon matPrefix>search</mat-icon>
          <button *ngIf="getColumnFilterSearch(columnKey)" 
                  matSuffix 
                  mat-icon-button 
                  (click)="onColumnFilterSearchChange(columnKey, '')"
                  matTooltip="Limpiar búsqueda">
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="space-y-2 max-h-64 overflow-hidden">
        <mat-checkbox
          [checked]="
            getSelectedColumnFilterValues(columnKey).length ===
            getFilteredColumnValues(columnKey).length
          "
          [indeterminate]="
            getSelectedColumnFilterValues(columnKey).length > 0 &&
            getSelectedColumnFilterValues(columnKey).length <
              getFilteredColumnValues(columnKey).length
          "
          (change)="
            onColumnFilterChange(columnKey, $event.checked ? getFilteredColumnValues(columnKey) : [])
          "
          class="font-medium"
        >
          Seleccionar todo ({{ getFilteredColumnValues(columnKey).length }} valores)
        </mat-checkbox>

        <mat-divider></mat-divider>

        <!-- Virtual scroll for filter values when there are many items -->
        <div class="max-h-48 overflow-hidden">
          <cdk-virtual-scroll-viewport 
            *ngIf="getFilteredColumnValues(columnKey).length > 20; else regularList"
            [itemSize]="36" 
            class="h-48">
            
            <div *cdkVirtualFor="let value of getFilteredColumnValues(columnKey); trackBy: trackByValue" 
                 class="flex items-center py-1 px-1">
              <mat-checkbox
                [checked]="getSelectedColumnFilterValues(columnKey).includes(value)"
                (change)="toggleColumnFilterValue(columnKey, value, $event.checked)"
                class="w-full checkbox-item"
                [class.highlighted]="isValueHighlighted(columnKey, value)"
              >
                <span class="truncate filter-value-text" [title]="value" [innerHTML]="highlightSearchTerm(value, getColumnFilterSearch(columnKey))"></span>
              </mat-checkbox>
            </div>
          </cdk-virtual-scroll-viewport>

          <!-- Regular list for smaller datasets -->
          <ng-template #regularList>
            <div class="max-h-48 overflow-y-auto space-y-1 px-1">
              <div *ngFor="let value of getFilteredColumnValues(columnKey); trackBy: trackByValue" 
                   class="flex items-center checkbox-item"
                   [class.highlighted]="isValueHighlighted(columnKey, value)">
                <mat-checkbox
                  [checked]="getSelectedColumnFilterValues(columnKey).includes(value)"
                  (change)="toggleColumnFilterValue(columnKey, value, $event.checked)"
                  class="w-full"
                >
                  <span class="truncate filter-value-text" [title]="value" [innerHTML]="highlightSearchTerm(value, getColumnFilterSearch(columnKey))"></span>
                </mat-checkbox>
              </div>
            </div>
          </ng-template>
        </div>

        <div
          *ngIf="getFilteredColumnValues(columnKey).length === 0 && getColumnFilterValues(columnKey).length > 0"
          class="text-gray-500 text-sm p-2 text-center"
        >
          No se encontraron valores que coincidan con "{{ getColumnFilterSearch(columnKey) }}"
        </div>

        <div
          *ngIf="getColumnFilterValues(columnKey).length === 0"
          class="text-gray-500 text-sm p-2 text-center"
        >
          No hay valores únicos en esta columna
        </div>
      </div>
    </div>
  </ng-template>
</mat-menu>
